module.exports = __webpack_public_path__ + "wallet.0bb6512b.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/icons/wallet.png
// module id = 7EYa
// module chunks = 0